import React, { useEffect, useState } from 'react';
import WebLogo from '../../../../assets/logos/websitelogo.svg';
import xlsx from '../images/xlsx.png';
import pdf from '../images/pdf.png';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { utils, writeFile } from 'xlsx';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
	getVisit,
	getPatientList,
	postVisitDatalist,
} from '../../../../app/services/api/apiManager';
import dayjs from 'dayjs';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import PatientReport from '../PatientReport';
import {
	borderColor,
	buttonStyles,
	button_Styles1,
	csvStyle,
	filterSectionStyle,
	grid_Button_Style,
	grid_Icon_Style,
	headerSection,
	pdfStyle,
	textStyling,
	titleWithTextfield,
	headerStyling,
} from './GeneralStyles';
import {
	Box,
	Button,
	Checkbox,
	Divider,
	Grid,
	Paper,
	Typography,
} from '@mui/material';

const LengthStayHistory = () => {
	// Get Data with Practice ID
	const practiceID = localStorage.getItem('practice_id');
	// Navigate to Page State
	const [currentPage, setCurrentPage] = useState(true);
	// Loader State
	const [isLoading, setIsLoading] = useState(true);
	// Api's Data State
	const [allVisits, setAllVisits] = useState([]); // Visit Api Data
	const [allPatientsData, setAllPatientsData] = useState([]); // Patient Api Data
	const [pdfUrl, setPdfUrl] = useState('');

	// Handle Patient Name ( Field ) State
	const [selectPatient, setSelectPatient] = useState([]);

	// Filter Data with TextShows Headlines State
	const [filterationData, setFilterationData] = useState([]);
	// Handle Date Value States
	const [dateValue, setDateValue] = useState({
		admitDate: dayjs().startOf('month'), // Get the start of the current month
		dischargeDate: dayjs(),
	});

	// Formate date
	const formatFromDate = dayjs(dateValue.admitDate).format('YYYY-MM-DD');
	const formatToDate = dayjs(dateValue.dischargeDate).format('YYYY-MM-DD');

	// Target Date Value Function
	const handleDateValue = (name, date) => {
		setDateValue({
			...dateValue,
			[name]: date,
		});
		getVisitListData(filterData);
	};

	// Handle Reset Value
	const resetValues = () => {
		setDateValue({
			admitDate: '',
			dischargeDate: '',
		}),
			setSelectPatient([]);
		setFilterationData([]);
		getVisitListData({ practice_id: practiceID });
	};

	// Function For Getting API Visits Data
	// const getVisits = async () => {
	// 	try {
	// 		// const response = await getChargesReport();
	// 		const response = await getVisit();
	// 		if (response?.status === 200) {
	// 			setAllVisits(response?.data);
	// 			console.log('Visits Data ==> ', response?.data);
	// 		}
	// 	} catch (error) {
	// 		console.error('Error fetching Visits:', error);
	// 	}
	// };

	// Patient Api function
	const getPatientData = async () => {
		// setPatientLoading(true);
		try {
			const response = await getPatientList(practiceID);
			setAllPatientsData(response?.data);
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// Define table styles
	const styles = {
		cellPadding: 1.5,
		fontSize: 10,
		halign: 'center',
		valign: 'middle',
		// fillColor: '#EEEEEE', // Background color of table cells
		// textColor: '#000000', // Text color of table cells
		fontStyle: 'normal', // Font style of table cells
		// overflow: 'ellipsize', // How to handle overflowing content
		lineWidth: 0.1, // Width of table borders
		lineColor: '#000000', // Color of table borders
	};

	// Define header styles
	const headerStyles = {
		fillColor: '#CCCCCC', // Background color of header row
		textColor: '#000000', // Text color of header row
		fontStyle: 'bold', // Font style of header row
	};

	// Download PDF File -- Filter Data

	{
		/*	const downloadFilterPDFData = (data) => {
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('Length of Stay History') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;
		// Set the font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('Length of Stay History', xPos, 15);
		// Reset the font if you need to add other non-bold text
		doc.setFont('helvetica', 'normal');
		let startY = 20; // Initial startY position

		const addPatientTitle = (title) => {
			doc.text(title, 10, startY + 10);
		};

		// const addTable = (data) => {

		doc.autoTable({
			startY: startY + 15,
			head: [
				[
					// Column Fields Name here
					'Serial No.',
					'Patient Name',
					'Sex',
					'DOB',
					// Dates
					'Admit Date',
					'Discharge Date',
					'Length of Stay',
					'Admitting Diagnoses',
				],
			],
			body: data?.map((item, index) => [
				index + 1,
				item?.patient?.Lname + ' ' + item?.patient?.Fname,
				item?.Gender == 'M'
					? 'Male'
					: item?.Gender == 'F'
						? 'Female'
						: item?.Gender == 'o' || item?.Gender == 'O'
							? 'other'
							: '',
				item?.DOB != null ? dayjs(item?.DOB).format('MM-DD-YYYY') : '',
				item?.Admission_date != null
					? dayjs(item?.Admission_date).format('MM-DD-YYYY')
					: '--',
				item?.discharge_date != null
					? dayjs(item?.discharge_date).format('MM-DD-YYYY')
					: '--',
				dayjs(item?.Admission_date).isValid()
					? dayjs(item?.discharge_date).isValid()
						? dayjs(item?.discharge_date).diff(
								dayjs(item?.Admission_date),
								'day'
							)
						: dayjs().diff(dayjs(item?.Admission_date), 'day')
					: '--',
				`${item?.Dx1Description === null ? '' : item?.Dx1Description + ', '}${item?.Dx2Description === null ? '' : item?.Dx2Description + ', '} ${item?.Dx3Description === null ? '' : item?.Dx3Description + ', '} ${item?.Dx4Description === null ? '' : item?.Dx4Description + ', '} ${item?.Dx5Description === null ? '' : item?.Dx5Description + ', '} ${item?.Dx6Description === null ? '' : item?.Dx6Description + ', '} ${item?.Dx7Description === null ? '' : item?.Dx7Description + ', '} ${item?.Dx8Description === null ? '' : item?.Dx8Description + ', '} ${item?.Dx9Description === null ? '' : item?.Dx9Description + ', '} ${item?.Dx10Description === null ? '' : item?.Dx10Description + ', '} ${item?.Dx11Description === null ? '' : item?.Dx11Description + ', '} ${item?.Dx12Description === null ? '' : item?.Dx12Description + ', '} `,
			]),
			styles: styles,
			headStyles: headerStyles, // Updated to headStyles
		});
		// };

		const addNewPageIfNeeded = (spaceNeeded) => {
			if (spaceNeeded) {
				doc.addPage();
				startY = 20; // Reset startY for the new page
			}
		};

		const uniquePatients = [
			...new Set(
				data.map((item) => item?.patient?.Fname + ' ' + item?.patient?.Lname)
			),
		];

		uniquePatients.forEach((patient, index) => {
			const patientData = data.filter(
				(item) => item?.patient?.Fname + ' ' + item?.patient?.Lname === patient
			);
			const patientTitle = `Patient: ${patient}`;

			const tableSpaceNeeded = patientData.length * 10 + 40;
			const spaceNeeded =
				startY + tableSpaceNeeded > doc.internal.pageSize.getHeight() - 20;

			addNewPageIfNeeded(spaceNeeded && index > 0);

			addPatientTitle(patientTitle);
			// addTable(patientData);

			startY = doc.autoTable.previous.finalY + 5;
		});

		doc.save('Length of Stay History.pdf');
	};*/
	}
	const downloadFilterPDFData = (data) => {
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('Length of Stay History') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;

		// Set the title font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('Length of Stay History', xPos, 15);

		// Reset the font for the rest of the text
		doc.setFont('helvetica', 'normal');
		let startY = 20;

		const addPatientTitle = (title) => {
			doc.text(title, 10, startY + 10);
		};

		const uniquePatients = [
			...new Set(
				data.map((item) => item?.patient?.Fname + ' ' + item?.patient?.Lname)
			),
		];

		uniquePatients.forEach((patient, index) => {
			// Start a new page for every patient after the first one
			if (index > 0) {
				doc.addPage();
				startY = 20; // Reset startY for the new page
			}

			// Add the patient's title
			const patientTitle = `Patient: ${patient}`;
			addPatientTitle(patientTitle);

			// Filter data for the specific patient
			const patientData = data.filter(
				(item) => item?.patient?.Fname + ' ' + item?.patient?.Lname === patient
			);

			// Add the table for this patient's data
			doc.autoTable({
				startY: startY + 15,
				head: [
					[
						'Serial No.',
						'Patient Name',
						'Sex',
						'DOB',
						'Admit Date',
						'Discharge Date',
						'Length of Stay',
						'Admitting Diagnoses',
					],
				],
				body: patientData?.map((item, index) => [
					index + 1,
					item?.patient?.Lname + ' ' + item?.patient?.Fname,
					item?.Gender === 'M'
						? 'Male'
						: item?.Gender === 'F'
							? 'Female'
							: 'Other',
					item?.DOB ? dayjs(item?.DOB).format('MM-DD-YYYY') : '',
					item?.Admission_date
						? dayjs(item?.Admission_date).format('MM-DD-YYYY')
						: '--',
					item?.discharge_date
						? dayjs(item?.discharge_date).format('MM-DD-YYYY')
						: '--',
					dayjs(item?.Admission_date).isValid()
						? dayjs(item?.discharge_date).isValid()
							? dayjs(item?.discharge_date).diff(
									dayjs(item?.Admission_date),
									'day'
								)
							: dayjs().diff(dayjs(item?.Admission_date), 'day')
						: '--',
					`${item?.Dx1Description || ''}, ${item?.Dx2Description || ''}, ${item?.Dx3Description || ''}`,
				]),
				styles: styles,
				headStyles: headerStyles, // Updated to headStyles
			});

			// Adjust startY for the next patient
			startY = doc.autoTable.previous.finalY + 5;
		});

		doc.save('Length of Stay History.pdf');
	};

	// Download PDF All Data
	const downloadAllDataPDF = () => {
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('Length of Stay History') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;

		// Set the Text font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('Length of Stay History', xPos, 15);
		doc.setFont('helvetica', 'normal');

		const uniquePatients = [
			...new Set(
				allVisits?.map((item) => item?.patient?.Fname + item?.patient?.Lname)
			),
		];

		let currentY = 25; // Initialize Y position

		uniquePatients.forEach((patientName) => {
			// Calculate the height needed for the current patient's title and table
			const titleHeight = 10; // Rough estimate for the title height
			const tableStartY = currentY + titleHeight + 10; // Adding margin
			const rowsPerPage = Math.floor(
				(doc.internal.pageSize.height - tableStartY) / 10
			);
			const filteredVisits = allVisits?.filter(
				(item) =>
					item?.patient?.Fname + '' + item?.patient?.Lname === patientName
			);

			const tableData = filteredVisits?.map((item, index) => [
				index + 1,
				item?.patient?.Lname + ' ' + item?.patient?.Fname,
				item?.Gender == 'M'
					? 'Male'
					: item?.Gender == 'F'
						? 'Female'
						: item?.Gender == 'o' || item?.Gender == 'O'
							? 'Other'
							: '',
				item?.DOB != null ? dayjs(item?.DOB).format('MM-DD-YYYY') : '--',
				item?.Admission_date != null
					? dayjs(item?.Admission_date).format('MM-DD-YYYY')
					: '--',
				item?.discharge_date != null
					? dayjs(item?.discharge_date).format('MM-DD-YYYY')
					: '--',
				dayjs(item?.Admission_date).isValid()
					? dayjs(item?.discharge_date).isValid()
						? dayjs(item?.discharge_date).diff(
								dayjs(item?.Admission_date),
								'day'
							)
						: dayjs().diff(dayjs(item?.Admission_date), 'day')
					: '--',
				`${item?.Dx1Description || ''}, ${item?.Dx2Description || ''}, ${item?.Dx3Description || ''}, ${item?.Dx4Description || ''}, ${item?.Dx5Description || ''}, ${item?.Dx6Description || ''}, ${item?.Dx7Description || ''}, ${item?.Dx8Description || ''}, ${item?.Dx9Description || ''}, ${item?.Dx10Description || ''}, ${item?.Dx11Description || ''}, ${item?.Dx12Description || ''}`,
			]);

			// Check if there is enough space on the current page for the title and at least one row of the table
			const estimatedTableHeight = tableData.length * 10; // Rough estimate for the table height (10 height per row)
			if (tableStartY + estimatedTableHeight > doc.internal.pageSize.height) {
				doc.addPage();
				currentY = 25; // Reset Y position after a new page is added
			}

			// Set the Text font to bold and add patient title
			doc.setFont('helvetica', 'bold');
			doc.text(`Patient: ${patientName}`, 14, currentY);
			doc.setFont('helvetica', 'normal');

			currentY += titleHeight; // Update Y position for the table

			var tableConfig = {
				startY: currentY,
				margin: { top: 10, right: 0, bottom: 4, left: 5 },
				tableWidth: 280,
				tableHeight: 30,
			};

			// Add the table for the current patient
			doc.autoTable({
				head: [
					[
						'Serial No.',
						'Patient Name',
						'Sex',
						'DOB',
						'Admit Date',
						'Discharge Date',
						'Length of Stay',
						'Admitting Diagnoses',
					],
				],
				body: tableData,
				styles: styles,
				headStyles: headerStyles,
				...tableConfig,
				didDrawPage: (data) => {
					currentY = data.cursor.y + 10; // Update Y position for the next title
				},
			});

			// Update the currentY to the end of the table
			currentY = doc.autoTable.previous.finalY + 10;
		});

		// Save the PDF document
		doc.save('Length of Stay History.pdf');
	};

	// Filter PDF Data
	const searchValuesFilter = () => {
		const filterationData = allVisits?.filter((item) => {
			// Check if patient matches the selected patient, if any selected
			const isPatientMatch =
				selectPatient?.length === 0 || selectPatient.includes(item?.patient_id);
			// Convert fromDate and toDate to Date objects

			const admissionDate = dateValue.admitDate
				? new Date(dateValue.admitDate)
				: null;
			const dischargeDate = dateValue.dischargeDate
				? new Date(dateValue.dischargeDate)
				: null;

			const admDate = new Date(item?.Admission_date);
			const discargeDate = new Date(item?.discharge_date);
			const isAdmissionDateMatch = !admissionDate || admDate >= admissionDate;
			const isDischargeDateMatch =
				!dischargeDate || discargeDate <= dischargeDate;

			// Return true if all conditions are met
			return isPatientMatch && isAdmissionDateMatch && isDischargeDateMatch;
		});

		downloadFilterPDFData(filterationData); // Calling Download Filter Data Function -- PDF File
		setFilterationData(filterationData);
	};

	// Function -- Download PDF Data
	const handleDownloadPdf = async () => {
		if (
			(selectPatient && selectPatient.length !== 0) ||
			dateValue.admitDate ||
			dateValue.dischargeDate
		) {
			searchValuesFilter(); // Filter Pdf
		} else {
			downloadAllDataPDF(); // All Data
		}
	};

	// Function - Download CSV File with All Data
	const downloadAllCSV = () => {
		const columns = [
			[
				// Colmn Fields Name here
				'Patient Name',
				'Sex',
				'DOB',
				// Dates
				'Admit Date',
				'Discharge Date',
				'Length of Stay',
				'Admitting Diagnoses',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);

		// Assuming allVisits is an array of objects
		allVisits?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.patient?.Lname + ',' + row?.patient?.Fname,
						row?.Gender == 'M'
							? 'Male'
							: row?.Gender == 'F'
								? 'Female'
								: row?.Gender == 'O' || row?.Gender == 'o'
									? 'other'
									: '',
						row?.DOB != null ? dayjs(row?.DOB).format('MM-DD-YYYY') : '--',
						row?.Admission_date != null
							? dayjs(row?.Admission_date).format('MM-DD-YYYY')
							: '--',
						row?.discharge_date != null
							? dayjs(row?.discharge_date).format('MM-DD-YYYY')
							: '--',
						dayjs(row?.Admission_date).isValid()
							? dayjs(row?.discharge_date).isValid()
								? dayjs(row?.discharge_date).diff(
										dayjs(row?.Admission_date),
										'day'
									)
								: dayjs().diff(dayjs(row?.Admission_date), 'day')
							: '--',
						`${row?.Dx1Description === null ? '' : row?.Dx1Description + ', '}${row?.Dx2Description === null ? '' : row?.Dx2Description + ', '} ${row?.Dx3Description === null ? '' : row?.Dx3Description + ', '} ${row?.Dx4Description === null ? '' : row?.Dx4Description + ', '} ${row?.Dx5Description === null ? '' : row?.Dx5Description + ', '} ${row?.Dx6Description === null ? '' : row?.Dx6Description + ', '} ${row?.Dx7Description === null ? '' : row?.Dx7Description + ', '} ${row?.Dx8Description === null ? '' : row?.Dx8Description + ', '} ${row?.Dx9Description === null ? '' : row?.Dx9Description + ', '} ${row?.Dx10Description === null ? '' : row?.Dx10Description + ', '} ${row?.Dx11Description === null ? '' : row?.Dx11Description + ', '} ${row?.Dx12Description === null ? '' : row?.Dx12Description + ', '} `,
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Length of Stay History.xlsx');
	};

	// Function - Download CSV File with Filter Data

	const downloadFilterCSVData = (data) => {
		const columns = [
			[
				// Colmn Fields Name here
				'Patient Name',
				'Sex',
				'DOB',
				// Dates
				'Admit Date',
				'Discharge Date',
				'Length of Stay',
				'Admitting Diagnoses',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);

		// Assuming allVisits is an array of objects
		data?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.patient?.Lname + ',' + row?.patient?.Fname,
						row?.Gender == 'M'
							? 'Male'
							: row?.Gender == 'F'
								? 'Female'
								: row?.Gender == 'O' || row?.Gender == 'o'
									? 'other'
									: '',
						row?.DOB != null ? dayjs(row?.DOB).format('MM-DD-YYYY') : '--',
						row?.Admission_date != null
							? dayjs(row?.Admission_date).format('MM-DD-YYYY')
							: '--',
						row?.discharge_date != null
							? dayjs(row?.discharge_date).format('MM-DD-YYYY')
							: '--',
						dayjs(row?.Admission_date).isValid()
							? dayjs(row?.discharge_date).isValid()
								? dayjs(row?.discharge_date).diff(
										dayjs(row?.Admission_date),
										'day'
									)
								: dayjs().diff(dayjs(row?.Admission_date), 'day')
							: '--',
						`${row?.Dx1Description === null ? '' : row?.Dx1Description + ', '}${row?.Dx2Description === null ? '' : row?.Dx2Description + ', '} ${row?.Dx3Description === null ? '' : row?.Dx3Description + ', '} ${row?.Dx4Description === null ? '' : row?.Dx4Description + ', '} ${row?.Dx5Description === null ? '' : row?.Dx5Description + ', '} ${row?.Dx6Description === null ? '' : row?.Dx6Description + ', '} ${row?.Dx7Description === null ? '' : row?.Dx7Description + ', '} ${row?.Dx8Description === null ? '' : row?.Dx8Description + ', '} ${row?.Dx9Description === null ? '' : row?.Dx9Description + ', '} ${row?.Dx10Description === null ? '' : row?.Dx10Description + ', '} ${row?.Dx11Description === null ? '' : row?.Dx11Description + ', '} ${row?.Dx12Description === null ? '' : row?.Dx12Description + ', '} `,
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Length of Stay History.xlsx');
	};

	// Filter PDF Data
	const searchValuesFilterCSV = () => {
		const filterationData = allVisits?.filter((item) => {
			// Check if patient matches the selected patient, if any selected
			const isPatientMatch =
				selectPatient?.length === 0 || selectPatient.includes(item?.patient_id);
			// Convert fromDate and toDate to Date objects

			const admissionDate = dateValue.admitDate
				? new Date(dateValue.admitDate)
				: null;
			const dischargeDate = dateValue.dischargeDate
				? new Date(dateValue.dischargeDate)
				: null;

			const admDate = new Date(item?.Admission_date);
			const discargeDate = new Date(item?.discharge_date);

			const isAdmissionDateMatch = !admissionDate || admDate >= admissionDate;
			const isDischargeDateMatch =
				!dischargeDate || discargeDate <= dischargeDate;

			// Return true if all conditions are met
			return isPatientMatch && isAdmissionDateMatch && isDischargeDateMatch;
		});

		downloadFilterCSVData(filterationData); // Calling Download Filter Data Function -- PDF File
		setFilterationData(filterationData);
	};

	// Function -- Download CSV Data
	const handleDownloadCSV = () => {
		if (
			(selectPatient && selectPatient.length !== 0) ||
			dateValue.admitDate ||
			dateValue.dischargeDate
		) {
			searchValuesFilterCSV(); // Filter CSV
		} else {
			downloadAllCSV(); // All Data
		}
	};

	//shahid zaman function from chargelist
	const getVisitListData = async (data) => {
		try {
			const response = await postVisitDatalist(data);
			if (response?.status === 200 || response?.status === 201) {
				setAllVisits(response?.data);
			} else {
				// setVisitDataList([]);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		}
	};

	// get data Through Post method
	const filterData = {
		practice_id: practiceID,
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				// await getPatientLists();
				// await getVisits();
				await getVisitListData(filterData); // Call Visit Function
				await getPatientData(); // Call Patient Function

				// Check if all data arrays are not empty
				if (allVisits && allPatientsData) {
					setIsLoading(false); // Stop loader if all data is available
				}
			} catch (error) {
				console.error('Error fetching data:', error);
				setIsLoading(false); // Stop loader in case of error
			}
		};

		fetchData();
	}, [dateValue, selectPatient]);

	return currentPage ? (
		isLoading ? (
			// Maxchart Logo instead of Loader
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '80vh',
				}}
			>
				<Box
					sx={{
						opacity: 0 /* Initially hide the logo */,
						animation:
							'fadeInOut 2s linear infinite' /* Apply the fade-in and fade-out animation */,
					}}
				>
					<img className="logo" src={WebLogo} alt="Website Logo" />
				</Box>
			</Box>
		) : (
			<Paper
				elevation={1}
				sx={{
					margin: '1rem',
				}}
			>
				<Box
					sx={{
						flexGrow: 1,
						height: {
							lg: '30vh',
							md: '40vh',
							sm: '45vh',
							xs: '75vh',
						},
					}}
				>
					<Box
						style={headerStyling}
						sx={{
							padding: {
								xl: '0.5rem',
								lg: '0.5rem',
								md: '0.5rem',
								sm: '0.5rem',
								xs: '0.3rem',
							},
						}}
					>
						<KeyboardBackspaceIcon
							sx={{
								fontSize: '1.5rem',
								color: 'black',
								bgcolor: 'white',
								borderRadius: '1rem',
								cursor: 'pointer',
								'&:hover': {
									bgcolor: 'black',
									color: 'white',
								},
							}}
							onClick={() => {
								setCurrentPage(false);
							}}
						/>
						<Typography
							style={headerSection}
							sx={{
								fontSize: {
									xl: '20px',
									lg: '20px',
									md: '20px',
									sm: '22px',
									xs: '16px',
								},
							}}
						>
							{' '}
							Length of Stay History
						</Typography>
					</Box>
					<Grid container item sx={{ padding: '15px' }}>
						<Grid
							container
							item
							spacing={3}
							sx={{
								p: '15px',
								margin: '1px',
								background: '#F6F6F6',
								borderRadius: '6px',
							}}
						>
							<Grid item xs={12} md={12} lg={12}>
								<Grid container spacing={2}>
									<Grid item xl={2.4} lg={2.4} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												Patient
											</Typography>
											{/*<FormControl style={borderColor} size="small">
												<InputLabel id="patient-label">Patient</InputLabel>
												<Select
													labelId="patient-label"
													id="patient"
													label="Patient"
													multiple
													value={selectPatient}
													onChange={(event) =>
														setSelectPatient(event.target.value)
													}
													renderValue={(selected) => {
														const selectedNames = selected.map((id) => {
															const patientData = allVisits?.find(
																(items) => items?.id == id
															);
															return patientData
																? `${patientData.patient.Fname} ${patientData.patient.Lname}`
																: '';
														});
														return selectedNames.join(', ');
													}}
													MenuProps={{
														PaperProps: {
															style: {
																height: '200px',
																width: '130px',
																overflowY: 'auto',
																overflowX: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													{allVisits?.map((items, index) => (
														<MenuItem key={index} value={items?.id}>
															<Checkbox
																checked={selectPatient.includes(items?.id)}
															/>

															{items?.patient?.Lname +
																', ' +
																items?.patient?.Fname}
														</MenuItem>
													))}
												</Select>
											</FormControl>*/}

											<FormControl style={borderColor} size="small">
												<InputLabel id="patient-label">Patient</InputLabel>
												<Select
													labelId="patient-label"
													id="patient"
													label="Patient"
													multiple
													value={selectPatient}
													onChange={(event) =>
														setSelectPatient(event.target.value)
													}
													// renderValue={(selected) => {
													// 	const selectedNames = selected.map((id) => {
													// 		const patientData = allPatientsData?.find(
													// 			(item) => item?.patient_id === id
													// 		);
													// 		return patientData ? patientData?.Name : '';
													// 	});
													// 	return selectedNames
													// 		.filter((name) => name)
													// 		.join(', '); // Ensures no empty strings are included
													renderValue={(selected) => {
														const selectedNames = selected
															.map((id) => {
																const patientData = allPatientsData?.find(
																	(item) => item?.patient_id === id
																);
																return patientData ? patientData?.Name : '';
															})
															.filter((name) => name); // Ensure no empty strings are included

														// Check how many items are selected
														if (selectedNames.length === 1) {
															// If only one item is selected, show the name
															return selectedNames[0];
														} else if (selectedNames.length > 1) {
															// If more than one item is selected, show "1 + more"
															return `${selectedNames[0]} + ${selectedNames.length - 1} more`;
														}
														return ''; // If no items are selected, show nothing
													}}
													MenuProps={{
														PaperProps: {
															style: {
																maxHeight: '300px',
																width: '130px',
																overflowY: 'auto',
																scrollbarWidth: 'thin',
																scrollbarColor: 'dark',
																msOverflowStyle: 'none',
																WebkitOverflowScrolling: 'touch',
															},
														},
													}}
												>
													{allPatientsData?.map((item, index) => (
														<MenuItem key={index} value={item?.patient_id}>
															<Checkbox
																checked={selectPatient.includes(
																	item?.patient_id
																)}
															/>
															{item?.Name}
														</MenuItem>
													))}
												</Select>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xl={2.4} lg={2.4} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												Admit Date
											</Typography>
											<FormControl style={borderColor}>
												<LocalizationProvider dateAdapter={AdapterDayjs}>
													<DatePicker
														value={dateValue.admitDate}
														name="admitDate"
														size="small"
														slotProps={{ textField: { size: 'small' } }}
														onChange={(event) =>
															handleDateValue('admitDate', event)
														}
													/>
												</LocalizationProvider>
											</FormControl>
										</Box>
									</Grid>
									<Grid item xl={2.4} lg={2.4} md={3} sm={6} xs={12}>
										<Box style={titleWithTextfield}>
											<Typography fontWeight={'bold'} fontSize={'14px'}>
												Discharge Date
											</Typography>
											<FormControl style={borderColor}>
												<LocalizationProvider dateAdapter={AdapterDayjs}>
													<DatePicker
														value={dateValue.dischargeDate}
														name="dischargeDate"
														size="small"
														slotProps={{ textField: { size: 'small' } }}
														onChange={(event) =>
															handleDateValue('dischargeDate', event)
														}
													/>
												</LocalizationProvider>
											</FormControl>
										</Box>
									</Grid>

									<Grid item md={3} lg={2} style={grid_Button_Style}>
										<Box
											sx={{
												display: 'flex',
												marginLeft: {
													lg: '2rem',
													md: '0rem',
												},
												marginTop: {
													lg: '0rem',
													xs: '1rem',
												},
											}}
										>
											<Button
												variant="contained"
												size="small"
												sx={{
													padding: '0.5rem 1.5rem',
													textTransform: 'capitalize',
													letterSpacing: '0.1rem',
													backgroundColor: '#ED2828',
												}}
												disabled={
													selectPatient.length != 0 ||
													dateValue.admitDate ||
													dateValue.dischargeDate
														? false
														: true
												}
												onClick={() => {
													resetValues();
												}}
											>
												{' '}
												Reset{' '}
											</Button>
										</Box>
									</Grid>
									<Grid item md={2} lg={2} style={grid_Icon_Style}>
										<Box
											sx={{
												display: 'flex',
												gap: '1rem',
												ml: {
													lg: '0rem',
													xs: '1.5rem',
												},
											}}
										>
											<Box
												component={'img'}
												src={xlsx}
												style={csvStyle}
												onClick={() => {
													// Download CSV File Format Data
													handleDownloadCSV();
												}}
											></Box>

											<Box
												component={'img'}
												src={pdf}
												style={pdfStyle}
												onClick={() => {
													// Download Pdf File Format Data
													handleDownloadPdf();
												}}
											></Box>
										</Box>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Box>
				<Divider />
				<Box
					style={filterSectionStyle}
					sx={{
						height: {
							xl: '55vh',
							lg: '55vh',
							md: '45vh',
							sm: '28vh',
							xs: '10vh',
						},
					}}
				>
					<Grid container>
						<Grid item xs={12}>
							{filterationData?.length > 0 ? null : (
								<Typography
									variant="body1"
									style={textStyling}
									sx={{
										fontSize: {
											xl: '20px',
											lg: '20px',
											md: '16px',
											sm: '12px',
											xs: '12px',
										},
									}}
									disabled
								>
									Please apply filter to get reports
								</Typography>
							)}
							{/*
								<Typography style={textStyling}>
									Please apply filter to get reports
								</Typography>
                        */}
						</Grid>
					</Grid>
				</Box>

				{pdfUrl ? (
					<div style={{ marginTop: '20px' }}>
						<iframe src={pdfUrl} width="100%" height="600px" title="PDF" />
					</div>
				) : (
					''
				)}
			</Paper>
		)
	) : (
		<PatientReport />
	);
};

export default LengthStayHistory;
